import { ref } from 'vue'
import { ApiService } from '../services/ApiService.js'
import { CV_CONFIG } from '../config/cvConfig.js'

export function useCvActions() {
  const isPdfGenerating = ref(false)
  const downloadError = ref(null)
  const saveError = ref(null)

  // Generate and download PDF - now using ApiService
  const downloadPdf = async (cvData, filename = null) => {
    isPdfGenerating.value = true
    downloadError.value = null

    try {
      const response = await fetch(CV_CONFIG.api.generatePdf, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/pdf',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
        },
        body: JSON.stringify(cvData)
      })

      if (response.ok) {
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename || `${cvData.personal_info?.full_name || 'CV'}.pdf`
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
        return { success: true }
      } else {
        const errorData = await response.json()
        downloadError.value = errorData.error || 'Failed to generate PDF'
        return { success: false, error: downloadError.value }
      }
    } catch (error) {
      console.error('PDF generation error:', error)
      downloadError.value = 'Network error occurred while generating PDF'
      return { success: false, error: downloadError.value }
    } finally {
      isPdfGenerating.value = false
    }
  }

  // Save CV draft - now using ApiService with better error handling
  const saveDraft = async (cvData, draftName = null) => {
    saveError.value = null

    try {
      const result = await ApiService.saveDraft(cvData, draftName)
      return { success: true, data: result }
    } catch (error) {
      console.error('Save draft error:', error)
      saveError.value = error.message
      return { success: false, error: saveError.value }
    }
  }

  // Clear errors
  const clearErrors = () => {
    downloadError.value = null
    saveError.value = null
  }

  return {
    isPdfGenerating,
    downloadError,
    saveError,
    downloadPdf,
    saveDraft,
    clearErrors
  }
}